var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.327 17.9872C7.89717 17.9872 7.529 17.834 7.2225 17.5275C6.916 17.221 6.76275 16.8528 6.76275 16.423V4.06425C6.76275 3.63442 6.916 3.26625 7.2225 2.95975C7.529 2.65325 7.89717 2.5 8.327 2.5H17.6857C18.1156 2.5 18.4837 2.65325 18.7902 2.95975C19.0967 3.26625 19.25 3.63442 19.25 4.06425V16.423C19.25 16.8528 19.0967 17.221 18.7902 17.5275C18.4837 17.834 18.1156 17.9872 17.6857 17.9872H8.327ZM5.31425 21C4.88442 21 4.51625 20.8467 4.20975 20.5402C3.90325 20.2337 3.75 19.8656 3.75 19.4357V6.44875C3.75 6.26758 3.80942 6.11758 3.92825 5.99875C4.04725 5.87992 4.19725 5.8205 4.37825 5.8205C4.55942 5.8205 4.70942 5.87992 4.82825 5.99875C4.94708 6.11758 5.0065 6.26758 5.0065 6.44875V19.4357C5.0065 19.5127 5.0385 19.5833 5.1025 19.6475C5.16667 19.7115 5.23725 19.7435 5.31425 19.7435H15.3012C15.4824 19.7435 15.6324 19.8029 15.7512 19.9217C15.8701 20.0408 15.9295 20.1908 15.9295 20.3717C15.9295 20.5529 15.8701 20.7029 15.7512 20.8217C15.6324 20.9406 15.4824 21 15.3012 21H5.31425Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.ebc260d450cd477cb23a53bba77f425d.svg";
export { ForwardRef as ReactComponent };